// removed by extract-text-webpack-plugin
module.exports = {"component":"_2kg9yG6hV9nExb-QM82v8N","hidden":"_2AL0bcaSpecdUSqtebvAaq","selected":"_3taZK-L9zivM7jMRxjVUm_","hasUnreads":"_1iFeiK1aq9lRoacN_S626M","vcard":"_2xDOnnCLcB-aibaR22uuic","sender":"_2NIx6x7nLh-NoENzGcVmx5","msgBody":"_1hV3FxCfpmZackX-VPlkf8","content":"_1B6FxtJLh2Mw6QclE-hdIZ","timestamp":"_37kZupldxQN5PUD0U86hyD","subject":"_3Je4ZlwIQ3LMof_BQ3T7GM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Messages/MessageThreadHeaderListItem/MessageThreadHeaderListItem.css
// module id = 1341
// module chunks = 0